
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private id: any;
  @Watch("id", { immediate: true })
  private idChange() {
    if (this.id) {
      this.getData();
    }
  }
  private data: any = [];
  private getData() {
    this.data = {
      身高: "163",
      年龄: "34",
      性别: "女性",
      测试时间: "2022-12-12 12:12:12",
      身体总水分: "31.4",
      蛋白质: "8.4",
      无机盐: "3.11",
      体脂肪: "11.9",
      肌肉量: "40.3",
      去脂体重: "42.9",
      体重: "54.8",
      脂肪体重: "54.8",
      骨骼肌: "23.3",
      肌肉体脂肪: "11.9",
      身体质量指数: "20.6",
      体脂百分比: "21.7",
      右上肢肌肉: "2.06",
      左上肢肌肉: "1.93",
      躯干肌肉: "18.3",
    };
  }
}
